<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="about-the-author">
<h1 style="padding-top:100px;">About the Author</h1>
<p>Laura lives in Lancashire with her two cats. As a child, she never enjoyed reading but could just about stomach Roald Dahl. Her passion for fiction grew during her teens, focusing on easy reading, horror stories and after finding a couple more brilliant authors in her twenties, she now can’t put a good book down. Her inspiration for writing has been sparked purely because of past readings. She starts typing and soon, an idea is turned into a story. She’s never sure how it will all end until she can’t think of anything else to type, then she knows it’s finished.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch001.vue?4387dff4